(function() { window.GUID_c22a3df5_3e0f_43b5_8cd4_b5ff022aeac0 = { getGuid: function() { return "c22a3df5-3e0f-43b5-8cd4-b5ff022aeac0"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SportEventResult extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, 'tr');
                this.$control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.offon('click.' + this.UniqueNamespace, 'tr', function (e) {
                    let href = $(this).data('href');
                    if (href != null) {
                        window.location.href = href;
                    }
                });
            }
            OnControlInstantiated() {
            }
        }
        Controls.SportEventResult = SportEventResult;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sportevent-result.js.map
